<template>
  <li class="room-card">
    <h2 class="title --center --card">{{ content.name }}</h2>
    <p class="room-card__subtitle">{{ maxPeople }}</p>
    <div class="room-card__content">
      <div class="room-card__image-container">
        <Image :source="content.images[0]" class="room-card__image" />
        <button class="room-card__image-button" @click.stop="openModal">
          <Icon id="image" />
        </button>
      </div>
      <div>
        <RawHtml :html="content.description" class="room-card__description" />
        <DetailsDropdown :content="content.more_infos" :details-label="labels.details" />
        <div class="room-card__buttons">
          <p class="room-card__price">{{ price }}</p>
          <Button :link="content.reservation_link" :label="labels.reserve" />
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'
import RawHtml from '@/components/global/RawHtml.vue'
import Button from '@/components/small/Button.vue'
import DetailsDropdown from '@/components/small/DetailsDropdown.vue'

export default {
  name: 'RoomCard',
  components: {
    Button,
    DetailsDropdown,
    Icon,
    Image,
    RawHtml,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    labels: {
      type: Object,
      required: true,
    },
  },
  computed: {
    maxPeople() {
      return this.labels.max.replace('{max}', this.content.max_people)
    },
    price() {
      return this.$t('global.price').replace('PRICE', this.content.from_price)
    },
  },
  methods: {
    openModal() {
      this.$parent.$emit('openModal', Object.values(this.content.images))
    },
  },
}
</script>
